module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-feature-img-2-d87950907d8cf660f27afda306f0832d.png";